import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=926e3ea8&scoped=true&"
import script from "./VideoCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./VideoCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./VideoCard.vue?vue&type=style&index=0&id=926e3ea8&lang=scss&scoped=true&"
import style1 from "./VideoCard.vue?vue&type=style&index=1&id=926e3ea8&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926e3ea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('926e3ea8')) {
      api.createRecord('926e3ea8', component.options)
    } else {
      api.reload('926e3ea8', component.options)
    }
    module.hot.accept("./VideoCard.vue?vue&type=template&id=926e3ea8&scoped=true&", function () {
      api.rerender('926e3ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/VideoCardLpu/VideoCard.vue"
export default component.exports